import { api } from "../Apis/interceptor";

export const pendingNotifications = function (customer_id, opp_id) {
  return api.get("/api/v1/pendingNotifications", {
    params: {
      customer_id: customer_id,
      opp_id: opp_id,
    },
  });
};
export const pendingCliNotifications = function (customer_id, opp_id) {
  return api.get("/api/v1/pendingCliNotifications", {
    params: {
      customer_id: customer_id,
      opp_id: opp_id,
    },
  });
};
export const getNotifications = function (customer_id, user_id) {
  return api.get("/api/v1/getNotifications", {
    params: {
      customer_id: customer_id,
      user_id: user_id,
    },
  });
};

export const getPendingCount = function (customer_id, user_id) {
  return api.get("/api/v1/getPendingCount", {
    params: {
      customer_id: customer_id,
      user_id: user_id,
    },
  });
};

export const updateStatus = function (customer_id, user_id) {
  return api.put("/api/v1/updateStatus", {
    customer_id: customer_id,
    user_id: user_id,
  });
};

export const clearNotifications = function (customer_id, user_id) {
  return api.put("/api/v1/clearNotifications", {
    customer_id: customer_id,
    user_id: user_id,
  });
};

//clear completed task notification

export const clearCompletedNotification = function (data) {
  return api.put("/api/v1/clearCompletedNotification", {
    action_ids: data,
  });
};

// export const clearCompletedNotifi=function(data){
//     return api.put('/api/v1/clearCompletedNotification',{

//             action_ids:data
//     });
// };
// reThrowNotification
export const reThrowNotification = function (data) {
  return api.put("/api/v1/reThrowNotifications", {
    action_ids: data,
  });
};
